import { type CheckContactValues } from '@widgets/auth/checkContact/config/phoneValidation';
import { NavigateFunction } from 'react-router-dom';

export interface CheckContactViewModel {
  isRemember: boolean;
  initialPhone: string;
  checkContact: (values: CheckContactValues) => Promise<void>;
  toggleIsRemember: () => void;
  forgotPasswordClick: (phone: string) => void;
  navigate: NavigateFunction | null;
  isLoading: boolean;
}

export const CheckContactViewModelToken = Symbol.for('CheckContactViewModel');
